import React from 'react';
import withStyles from 'react-jss';
import Table from '../../components/Table/Table';
import Row from '../../components/Table/Row/Row';
import Cell from '../../components/Table/Row/Cell/Cell';
import { Link, withRouter } from 'react-router-dom';
import Entity from '../../components/Entity/Entity';
import { queryObject } from '../../services/Utils/query';
import { useShips } from '../../services/Firestore/Resources';

const styles = {
  root: {
    display: 'grid',
    gridGap: '5px',
  },
};

const ShipList = ({ classes, match, filter }) => {
  const [ships, shipsLoading] = useShips();

  if (shipsLoading) {
    return <div>Loading...</div>;
  }
  return (
    <div className={classes.root}>
      <Table>
        <Row>
          <Cell header>Name</Cell>
          <Cell header>Address</Cell>
        </Row>
        {ships && Object.values(ships).length > 0 ? (
          Object.values(queryObject(ships, filter, ['address', 'name'])).map((row) => (
            <Row key={row.id}>
              <Cell>
                <Link to={match.url + '/' + row.id}>
                  <Entity title={row.name} deleted={row.deleted} />
                </Link>
              </Cell>
              <Cell>
                <Entity title={row.address} deleted={row.deleted} />
              </Cell>
            </Row>
          ))
        ) : (
          <Row>
            <Cell>No rows</Cell>
          </Row>
        )}
      </Table>
    </div>
  );
};

export default withRouter(withStyles(styles)(ShipList));
